"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _FormLabel = _interopRequireDefault(require("./FormLabel"));

var _index2 = require("./form-text-field/index");

var _HelpHint = _interopRequireDefault(require("../tooltips/HelpHint"));

var _InputWidths = require("./InputWidths");

var _Icon = _interopRequireDefault(require("../general/Icon"));

var _EventUtils = require("../../util/EventUtils.js");

var _classnames = _interopRequireDefault(require("classnames"));

var _FilterUtils = require("../../util/FilterUtils.js");

var _KeyboardUtils = require("../../util/KeyboardUtils.js");

var _Utils = _interopRequireDefault(require("../../util/Utils.js"));

var _underscore = _interopRequireDefault(require("underscore"));

var _PopperContainer = _interopRequireDefault(require("../tooltips/PopperContainer"));

var _PopperContainerContext = _interopRequireDefault(require("../tooltips/PopperContainerContext"));

var _StateContainer = require("../utils/StateContainer");

var _DeprecationUtils = require("../../util/DeprecationUtils");

var _PropUtils = require("../../util/PropUtils");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context21; _forEachInstanceProperty2(_context21 = ownKeys(Object(source), true)).call(_context21, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context22; _forEachInstanceProperty2(_context22 = ownKeys(Object(source))).call(_context22, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
* @function FormDropDownList~filterOptions
* @desc Filters the given list of options with the filter string
*
* @param {array<FormDropDownList~option>} options
*    The array of options to filter
* @param {string} filterString
*    The string to use to filter the options
*
* @return {array<FormDropDownList~option>}
*    Returns the list of filtered options
*/
var filterOptions = function filterOptions(options, filterString) {
  return (0, _filter.default)(options).call(options, (0, _bind.default)(_FilterUtils.filterFieldContains).call(_FilterUtils.filterFieldContains, null, "label", filterString));
};
/**
 * @enum {string}
 * @alias FormDropDownList.SearchTypes
 */


var SearchTypes = {
  KEYBOARD: "keyboard",
  BOX: "box"
};
/**
* @callback FormDropDownList~onToggle
*/

/**
* @callback FormDropDownList~onFocus
 * @param {Event} event
 *      Synthetic React focus event
*/

/**
* @callback FormDropDownList~onBlur
 * @param {Event} event
 *      Synthetic React blur event
*/

/**
* @callback FormDropDownList~onSearch
*
* @param {string} searchString
*    The text to search with.
* @param {number} searchTime
*    The time after which to clear the search when the user delays their search.
*    Not applicable when searchType = BOX.
* @param {number} searchIndex
*    The index of the option that was just searched.
*    Not applicable when searchType = BOX.
*/

/**
* @callback FormDropDownList~onValueChange
*
* @param {FormDropDownList~option} option
*    The newly selected list option.
*/

/**
* @callback FormDropDownList~onAdd
*
* @param {string} label
*    The label for the new option to be added.
*/

/**
* @typedef FormDropDownList~option
* @desc A single list option. Must contain a label and value.
*    If groups is enabled, can pass a group id if option should be part of a group.
*    Additional properties will be passed to the contentType as props.
*
* @property {string} label
*     The label of the option.
* @property {string} value
*     The value of the option.
* @property {string|number} [group]
*     The id of the group the option belongs to.
* @property {string} helpHintText
*     The help text to display in a tooltip when hovering over an option
*/

/**
* @typedef FormDropDownList~group
* @desc A single group section.
*
* @property {string|number} id
*     The id of the group.
* @property {string} label
*     The label of the group.
* @property {boolean} disabled
*     Whether or not this group should be disabled.
*/

/**
* @class FormDropDownList
* @desc A generic select (dropdown) component. Encapsulates common markup and designed to be a drop-in replacement.
*       The array of options will insure display order of options. Has tabbing, up/down key, and search support.
*
* @param {string} [data-id="form-drop-down-list"]
*    To define the base "data-id" value for the top-level HTML container.
* @param {string} [className]
*    CSS classes to set on the top-level HTML container.
* @param {node} [errorMessage]
*     The message to display if defined when external validation failed.
* @param {string} [helpClassName]
*     CSS classes to set on the HelpHint component.
* @param {string} [iconName]
*     adds an icon to the option
* @param {string} [label]
*     The text to display as the field's label.
* @param {node} [description]
*     Description to display below the label.
* @param {string} [name]
*     The name attribute for the input.
* @param {array<FormDropDownList~option>} options
*    Array of options for the dropdown list. Each option should have a label and value,
*    but value is required and label is not. If no label is passed in Value will take the place of label.
*    Additional properties of the option object will be passed as props to the contentType.
* @param {FormDropDownList~option} selectedOption
*    The selected list option.
* @param {FormDropDownList~onValueChange} [onValueChange]
*    Callback to be triggered when an option is selected.
*
* @param {element} [contentType=FormDropDownListDefaultContent]
*    A custom element representing the contents of each option.
*
* @param {array<FormDropDownList~group>} [groups]
*    Array of group sections for the dropdown list. If specified, will enable grouping of options.
*    Order of the groups is preserved in the dropdown list, and the order of options in each group
*    will be preserved with the order in which they were specified in the options prop.
*
* @param {boolean} [open=false]
*    State of the open/closed dropdown menu.
* @param {FormDropDownList~onToggle} [onToggle]
*    Callback to be triggered when the open/closed state changes.
*
* @param {string} [labelAdd]
*    The label for the add new option preview prompt.
* @param {string} [labelHelpText]
*     The text to display for the help tooltip.
* @param {string} [labelPrompt]
*    The label for the prompt displayed when using BOX searchType.
* @param {string} [name]
*     The name attribute for the input.
* @param {string} [noneOptionLabelClassName]
*    CSS classes to set on the label for the none option.
* @param {string} [placeholder]
*    Placeholder string for the input
* @param {string} [searchField="label"]
*    The field value to use in the search.
* @param {number} [searchIndex=-1]
*    The index of the option that was just searched. Allows for highlighting and up/down arrow movement.
*    When not provided, the component will manage this value.
* @param {string} [searchString=""]
*    Value to help with finding an option on keydown.
*    When not provided, the component will manage this value.
* @param {number} [searchTime=0]
*    Time to help clear the search when the user delays their search.
*    When not provided, the component will manage this value.
* @param {string} [selectClassName]
*    CSS classes to set on the select.
* @param {string} [selectedOptionLabelClassName]
*    CSS classes to set on the selected list option label.
* @param {string} [title=""]
*    The tooltip title to give the selected option.
* @param {string} [validSearchCharsRegex=/[^a-zA-Z\d\s]+/]
*    A regex of the valid characters for the search. Allows alphanumeric and whitespace by default.
* @param {InputWidths} [width]
*    Specifies the width of the input.
*
* @param {array<FormDropDownList~option>} options
*    Array of options for the dropdown list. Each option should have a label and value.
*    Additional properties of the option object will be passed as props to the contentType.
* @param {FormDropDownList~option} selectedOption
*    The selected list option.
* @param {FormDropDownList~onValueChange} [onValueChange]
*    Callback to be triggered when an option is selected.
* @param {boolean} [autofocus=false]
*    Whether or not this field should autofocus.
* @param {boolean} [canAdd=false]
*    Whether or not adding new options to the list is enabled.
*    Will override searchType to use BOX type searching when true.
* @param {boolean} [disabled=false]
*     If true, the select element will be disabled.
* @param {boolean} [open=false]
*    State of the open/closed dropdown menu.
*    When not provided, the component will manage this value.
* @param {boolean} [required=false]
*     If true, the user must select a value for this field.
* @param {boolean} [showSelectedOptionLabel=true]
*    Whether or not to display the label text for the selected option.
* @param {FormDropDownList.onAdd} [onAdd]
*    Callback to be triggered when a new option is to be added to the list.
* @param {FormDropDownList~onSearch} [onSearch]
*    Callback to be triggered when the state of the search of an option when the list dropdown is expanded changes.
* @param {FormDropDownList~onBlur} [onBlur]
*    Callback to be triggered when search input looses focus
* @param {FormDropDownList~onFocus} [onFocus]
*    Callback to be triggered when search input gets focus
* @param {FormDropDownList~onToggle} [onToggle]
*    Callback to be triggered when the open/closed state changes.
* @param {array<FormDropDownList~group>} [groups]
*    Array of group sections for the dropdown list. If specified, will enable grouping of options.
*    Order of the groups is preserved in the dropdown list, and the order of options in each group
*    will be preserved with the order in which they were specified in the options prop.
* @param {FormDropDownList~option} [noneOption]
*    If specified, adds an option which does not count as a selection (e.g., "select an option").
*    This option will be shown at the top of the dropdown list.
*    The object should specify the label of the none option.
* @param {FormDropDownList.SearchTypes} [searchType="KEYBOARD"]
*    The type of search to use with the dropdown list.
*    If the "add" prop is set to true, will override to use BOX type of searching.
*
* @param {element} [contentType=FormDropDownListDefaultContent]
*    A custom element representing the contents of each option.
*
* @param {FormSearchBox~renderList} [renderList]
*     Renders a custom list
* @param {FormSearchBox~renderInput} [onClear]
*     Rende function for the input
*/

/**
* @class FormDropDownListDefaultContent
* @desc A simple default content type for the FormDropDownList that just renders the label of each option.
* @memberof FormDropDownList
*
* @param {string} label
*    The label to render.
* @param {string} value
*    The value to render if label is not provided. This value is required.
*/

var FormDropDownListDefaultContent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FormDropDownListDefaultContent, _React$Component);

  var _super = _createSuper(FormDropDownListDefaultContent);

  function FormDropDownListDefaultContent() {
    (0, _classCallCheck2.default)(this, FormDropDownListDefaultContent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FormDropDownListDefaultContent, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("span", null, this.props.label ? this.props.label : this.props.value);
    }
  }]);
  return FormDropDownListDefaultContent;
}(_react.default.Component);

(0, _defineProperty2.default)(FormDropDownListDefaultContent, "propTypes", {
  label: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
});
(0, _defineProperty2.default)(FormDropDownListDefaultContent, "defaultProps", {
  value: ""
});

var OptionItem = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(OptionItem, _React$Component2);

  var _super2 = _createSuper(OptionItem);

  function OptionItem() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, OptionItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleClick", function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(_this.props.option, event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderContent", function () {
      var content = _this.props.iconName ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        iconName: _this.props.iconName,
        className: "select-option__icon",
        type: "leading"
      }, _this.props.content)) : /*#__PURE__*/_react.default.createElement("div", null, _this.props.content);

      if (_this.props.option.helpHintText) {
        return /*#__PURE__*/_react.default.createElement(_HelpHint.default, {
          "data-id": _this.props["data-id"] + "-helphint",
          delayHide: 0,
          placement: "right",
          hintText: _this.props.option.helpHintText
        }, content);
      } else {
        return content;
      }
    });
    return _this;
  }

  (0, _createClass2.default)(OptionItem, [{
    key: "render",
    value: function render() {
      var className = {
        "help-hint-option": this.props.option.helpHintText,
        "select-option__placeholder": this.props.iconPlaceholder && this.props.iconName === undefined
      };
      return /*#__PURE__*/_react.default.createElement("li", {
        "data-id": this.props["data-id"],
        className: (0, _classnames.default)(this.props.className, className),
        onClick: this._handleClick
      }, this._renderContent());
    }
  }]);
  return OptionItem;
}(_react.default.Component);

(0, _defineProperty2.default)(OptionItem, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  content: _propTypes.default.node,
  iconName: _propTypes.default.string,
  onClick: _propTypes.default.func,
  option: _propTypes.default.object,
  iconPlaceholder: _propTypes.default.bool
});
(0, _defineProperty2.default)(OptionItem, "defaultProps", {
  content: null
});

var FormDropDownListStateless = /*#__PURE__*/function (_React$Component3) {
  (0, _inherits2.default)(FormDropDownListStateless, _React$Component3);

  var _super3 = _createSuper(FormDropDownListStateless);

  function FormDropDownListStateless(props) {
    var _this2;

    (0, _classCallCheck2.default)(this, FormDropDownListStateless);
    _this2 = _super3.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "didPressKey", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "inlineMenuStyle", _Utils.default.isIE() ? {
      border: "none"
    } : {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getOptionLabel", function (_ref) {
      var label = _ref.label,
          value = _ref.value;

      if (label !== null && label !== undefined) {
        return label;
      } else {
        return value;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getLabelOptions", function (options) {
      return (0, _map.default)(_underscore.default).call(_underscore.default, options, function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          label: _this2._getOptionLabel(option)
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_onSearchProxy", function (search, time, index) {
      _this2.props.onSearch(search, time, index);

      _this2.props.setSearchString(search);

      _this2.props.setSearchTime(time);

      _this2.props.setSearchIndex(index);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_filteredOptions", function () {
      return _this2.props.canAdd || _this2.props.searchType === SearchTypes.BOX ? filterOptions(_this2._getLabelOptions(_this2.props.options), _this2.props.searchString) : _this2._getLabelOptions(_this2.props.options);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_onToggleProxy", function () {
      var _context2;

      _this2.props.onToggle();

      _this2.props.setSearchIndex((0, _findIndex.default)(_context2 = _this2._orderedOptions).call(_context2, function (o) {
        return _this2.props.selectedOption && _this2.props.selectedOption.value === o.value;
      }));

      _this2.props.setSearchTime(-1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_setupGroups", function (_ref2) {
      var groups = _ref2.groups;

      if (groups) {
        var _context3;

        // Groups by id
        _this2._groupById = {};
        (0, _forEach.default)(groups).call(groups, function (group) {
          _this2._groupById[group.id] = group;
        }); // Sort all options into groups

        var groupedOptions = {};
        (0, _forEach.default)(_context3 = _this2._filteredOptions()).call(_context3, function (option) {
          if (groupedOptions[option.group || "undefined"]) {
            groupedOptions[option.group || "undefined"].push(option);
          } else {
            groupedOptions[option.group || "undefined"] = [option];
          }
        }); // Order options: undefined first then all other groups
        // in the same group/options order specified in groups/options props

        _this2._orderedOptions = [];

        if (groupedOptions["undefined"]) {
          var _context4;

          _this2._orderedOptions = (0, _concat.default)(_context4 = _this2._orderedOptions).call(_context4, groupedOptions["undefined"]);
        }

        (0, _forEach.default)(groups).call(groups, function (groupItem) {
          if (groupedOptions[groupItem.id]) {
            var _context5;

            _this2._orderedOptions = (0, _concat.default)(_context5 = _this2._orderedOptions).call(_context5, groupedOptions[groupItem.id]);
          }
        });
      } else {
        _this2._orderedOptions = _this2.props.options;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleGlobalClick", function (e) {
      // if the click event isn't the click that opened the list
      if (_this2.props.open && _this2._clickEvent !== e) {
        var picker = _reactDom.default.findDOMNode(_this2.refs["input-container"]); //dont close the list if the click is on the select


        (0, _EventUtils.callIfOutsideOfContainer)(picker, _this2._closeList, e);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_closeList", function () {
      _this2._onToggleProxy();

      _this2._onSearchProxy("", 0, 0);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getOrderedOptionsIndex", function (option) {
      var _context6;

      return _this2.props.groups && option ? (0, _findIndex.default)(_context6 = _this2._orderedOptions).call(_context6, function (_ref3) {
        var value = _ref3.value;
        return value === option.value;
      }) : -1;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_isBoxSearch", function () {
      return _this2.props.canAdd || _this2.props.searchType === SearchTypes.BOX;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_isKeyboardSearch", function () {
      return !_this2.props.canAdd && _this2.props.searchType === SearchTypes.KEYBOARD;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_isPromptVisible", function () {
      if (!_this2._isBoxSearch() || _this2.props.searchString === "" || !_this2.props.canAdd) {
        return false;
      } else {
        var _context7, _context8;

        var cleanSearch = (0, _trim.default)(_context7 = _this2.props.searchString.toLowerCase()).call(_context7);
        return (0, _some.default)(_context8 = _this2._getLabelOptions(_this2.props.options)).call(_context8, function (_ref4) {
          var _context9;

          var label = _ref4.label;
          return (0, _trim.default)(_context9 = label.toLowerCase()).call(_context9) === cleanSearch;
        }) ? false : true;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getPrompt", function () {
      if (_this2._isBoxSearch()) {
        var className = "select-prompt",
            searchClassName = (0, _classnames.default)(className, "select-search-prompt"),
            addClassName = (0, _classnames.default)(className, "select-add", {
          highlighted: _this2._filteredOptions().length === 0 || _this2.props.searchIndex === 0
        });

        if (_this2.props.searchString === "") {
          return /*#__PURE__*/_react.default.createElement("li", {
            "data-id": "search-prompt",
            className: searchClassName
          }, _this2.props.labelPrompt);
        } else if (_this2.props.canAdd) {
          var _context10, _context11;

          var cleanSearch = (0, _trim.default)(_context10 = _this2.props.searchString.toLowerCase()).call(_context10); // Cannot add if duplicate

          return (0, _some.default)(_context11 = _this2._getLabelOptions(_this2.props.options)).call(_context11, function (_ref5) {
            var _context12;

            var label = _ref5.label;
            return (0, _trim.default)(_context12 = label.toLowerCase()).call(_context12) === cleanSearch;
          }) ? null : /*#__PURE__*/_react.default.createElement("li", {
            "data-id": "add-prompt",
            className: addClassName,
            onClick: _this2._handleAddClick
          }, _this2.props.labelAdd !== undefined ? /*#__PURE__*/_react.default.createElement("span", {
            className: "label"
          }, _this2.props.labelAdd) : null, /*#__PURE__*/_react.default.createElement("span", null, _this2.props.searchString));
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleInputValueChange", function (searchString) {
      if (!_this2.props.open) {
        _this2._onToggleProxy();
      }

      _this2._onSearchProxy(searchString, 0, 0);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleAdd", function () {
      _this2.props.onAdd(_this2.props.searchString);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleAddClick", function () {
      _this2._handleAdd();

      _this2._onSearchProxy("", 0, _this2.props.noneOption ? -1 : 0);

      _this2._onToggleProxy();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleKeyDown", function (e) {
      _this2.didPressKey = true;
      var keyCode = e.keyCode;
      var _this2$props = _this2.props,
          canAdd = _this2$props.canAdd,
          groups = _this2$props.groups,
          noneOption = _this2$props.noneOption,
          onValueChange = _this2$props.onValueChange,
          open = _this2$props.open,
          searchField = _this2$props.searchField,
          searchIndex = _this2$props.searchIndex,
          searchString = _this2$props.searchString,
          searchTime = _this2$props.searchTime,
          validSearchCharsRegex = _this2$props.validSearchCharsRegex;

      if ((0, _KeyboardUtils.isArrowUp)(keyCode) || (0, _KeyboardUtils.isArrowDown)(keyCode)) {
        _this2._handleUpDownKeys(e);

        return;
      }

      if (!open) {
        if ((0, _KeyboardUtils.isEnter)(keyCode) || (0, _KeyboardUtils.isSpace)(keyCode)) {
          e.preventDefault();

          _this2._onToggleProxy();
        }

        return;
      }

      if ((0, _KeyboardUtils.isEnter)(keyCode)) {
        // Enter, so pull previously entered search string
        var hasPrompt = _this2._isPromptVisible();

        var isItemSelected = !canAdd && searchIndex >= 0 || hasPrompt && searchIndex > 0 || !hasPrompt && canAdd && searchIndex >= 0;
        var isPromptSelected = hasPrompt && canAdd && (searchIndex === 0 || searchIndex === -1 && searchString !== "");

        if (isPromptSelected && (searchString !== "" || noneOption)) {
          // Add the new option
          _this2._handleAdd();
        } else if (!isPromptSelected && isItemSelected) {
          // Select the current option
          if (groups) {
            var option = _this2._orderedOptions[hasPrompt ? searchIndex - 1 : searchIndex];

            if (!option || option.disabled) {// option itself is disabled or does not exist; ignoring;
            } else if (option.group && _this2._groupById[option.group] && _this2._groupById[option.group].disabled) {// option's parent group is disabled; ignoring;
            } else {
              onValueChange(option);
            }
          } else {
            var _option = _this2._filteredOptions()[hasPrompt ? searchIndex - 1 : searchIndex];

            if (!_option.disabled) {
              onValueChange(_option);
            }
          }
        } else if (searchIndex === -1 && noneOption) {
          onValueChange(noneOption);
        } // Reset dropdown


        _this2._onSearchProxy("", 0, noneOption ? -1 : 0);

        _this2._onToggleProxy();
      } else if ((0, _KeyboardUtils.isTab)(keyCode)) {
        _this2._onToggleProxy();
      } else if ((0, _KeyboardUtils.isEsc)(keyCode)) {
        // ESC, so clear
        _this2._onSearchProxy("", 0, noneOption ? -1 : 0);

        _this2._onToggleProxy();
      } else if (_this2._isKeyboardSearch()) {
        // Regex specifies valid characters, not i18n friendly right now
        if (String.fromCharCode(keyCode).toLowerCase().search(validSearchCharsRegex) < 0) {
          var char = String.fromCharCode(keyCode).toLowerCase();
          var time = (0, _now.default)();
          var search = searchTime > 0 && time - searchTime < 1000 ? searchString + char : char;

          var labeledOptions = _this2._getLabelOptions(_this2.props.options);

          var _option2 = (0, _find.default)(labeledOptions).call(labeledOptions, function (o) {
            var _context13;

            return (0, _indexOf.default)(_context13 = o[searchField].toLowerCase()).call(_context13, search) === 0;
          });

          var index = groups ? _this2._getOrderedOptionsIndex(_option2) : (0, _indexOf.default)(labeledOptions).call(labeledOptions, _option2); // again, not i18n friendly

          _this2._onSearchProxy(_option2 ? search : "", (0, _now.default)(), index);
        } else if (searchString) {
          // invalid character entered
          _this2._onSearchProxy("", (0, _now.default)(), noneOption ? -1 : 0);
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleUpDownKeys", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var keyCode = e.keyCode;

      if (_this2.props.open) {
        var _this2$props2 = _this2.props,
            noneOption = _this2$props2.noneOption,
            options = _this2$props2.options,
            searchIndex = _this2$props2.searchIndex,
            searchString = _this2$props2.searchString;

        if ((0, _KeyboardUtils.isArrowUp)(keyCode)) {
          var lowest = noneOption ? -1 : 0;
          var index = searchIndex - 1 >= -1 && searchIndex > lowest ? searchIndex - 1 : lowest;

          _this2._onSearchProxy(searchString, 0, index);
        } else {
          // down arrow
          var lastIndex = options.length - 1;

          var _index = searchIndex + 1 <= lastIndex ? searchIndex + 1 : lastIndex;

          _this2._onSearchProxy(searchString, 0, _index);
        }
      } else if (!_this2.props.disabled) {
        _this2._onToggleProxy();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_setSearchListPosition", function () {
      if (!_this2.props.open) {
        return;
      }

      var _this2$props3 = _this2.props,
          index = _this2$props3.searchIndex,
          options = _this2$props3.options,
          option = options[index],
          selectList = _reactDom.default.findDOMNode(_this2.refs["selectList"]),
          selectListTarget = option ? "option-" + index : _this2.props.noneOption ? "none-option" : "option-0",
          selectListItem = _reactDom.default.findDOMNode(_this2.refs[selectListTarget]);

      selectList.scrollTop = selectListItem ? selectListItem.offsetTop - 50 : 0;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleToggle", function (e) {
      if (!_this2.props.disabled) {
        // store a reference to this event so that we dont open and then close the list when the
        // global click event listener gets triggered.
        _this2._clickEvent = e.nativeEvent;

        _this2._onToggleProxy();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleOptionClick", function (item, e) {
      e.preventDefault(); // TODO: remove after refactor of DOM

      _this2.props.onValueChange(item);

      _this2._onToggleProxy();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getGroupSeparator", function (index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "group-separator" + index,
        className: "group-separator"
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getSingleGroupHeader", function (_ref6) {
      var disabled = _ref6.disabled,
          id = _ref6.id,
          label = _ref6.label;
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "select-group-" + id,
        ref: "select-group-" + id,
        "data-id": "select-group-" + id,
        className: (0, _classnames.default)("select-group", {
          disabled: disabled
        })
      }, label);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getSingleOption", function (hasIcon) {
      return function (option, i) {
        var _context14;

        var hasPrompt = _this2._isPromptVisible();

        var index = hasPrompt ? i + 1 : i;
        var group = _this2.props.groups && _this2._groupById[option.group],
            disabled = group && group.disabled || option.disabled,
            className = (0, _classnames.default)("select-option", {
          highlighted: !disabled && index === _this2.props.searchIndex,
          selected: option.value === (_this2.props.selectedOption && _this2.props.selectedOption.value),
          disabled: disabled
        });
        return /*#__PURE__*/_react.default.createElement(OptionItem, {
          key: (0, _concat.default)(_context14 = "option-".concat(option.label, "-")).call(_context14, option.value) // add prop allows re-ordering, so must have unique key
          ,
          ref: "option-" + index,
          "data-id": "option_" + option.value,
          className: className,
          onClick: !disabled ? _this2._handleOptionClick : _underscore.default.noop,
          option: option,
          content: /*#__PURE__*/_react.default.cloneElement(_this2.props.contentType, option),
          iconName: option.iconName,
          iconPlaceholder: hasIcon
        });
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getNoneOption", function () {
      var noneOptionContainerClassName = (0, _classnames.default)("none-option", {
        highlighted: _this2.props.searchIndex === -1,
        selected: _this2.props.selectedOption.label === _this2.props.noneOption.label
      }),
          content = /*#__PURE__*/_react.default.createElement("span", {
        className: _this2.props.noneOptionLabelClassName
      }, _this2.props.noneOption.label);

      return /*#__PURE__*/_react.default.createElement(OptionItem, {
        key: "none-option",
        "data-id": "none-option",
        ref: "none-option",
        className: noneOptionContainerClassName,
        onClick: _this2._handleOptionClick,
        option: _this2.props.noneOption,
        content: content
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getGroupedOptions", function (hasIcon) {
      var _context15;

      return (0, _reduce.default)(_context15 = _this2._orderedOptions).call(_context15, function (_ref7, _ref8, index) {
        var _context16;

        var lastGroup = _ref7.lastGroup,
            opts = _ref7.opts;
        var group = _ref8.group,
            opt = (0, _objectWithoutProperties2.default)(_ref8, ["group"]);
        return {
          lastGroup: group,
          opts: (0, _concat.default)(_context16 = []).call(_context16, opts, group && group !== lastGroup ? [_this2._getGroupSeparator(index), _this2._getSingleGroupHeader(_this2._groupById[group])] : [], [_this2._getSingleOption(hasIcon)(_objectSpread({
            group: group
          }, opt), index)])
        };
      }, {
        lastGroup: null,
        opts: []
      }).opts;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_generateOptions", function (hasIcon) {
      var _context17, _context18;

      return (0, _concat.default)(_context17 = []).call(_context17, _this2.props.noneOption && !_this2.props.searchString ? [_this2._getNoneOption()] : [], _this2.props.groups ? _this2._getGroupedOptions(hasIcon) : (0, _map.default)(_context18 = _this2._filteredOptions()).call(_context18, _this2._getSingleOption(hasIcon)));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getSelectedOptionLabel", function () {
      if (_this2.props.showSelectedOptionLabel && _this2.props.selectedOption) {
        return _this2._getOptionLabel(_this2.props.selectedOption);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getReference", function () {
      return _this2.reference;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_getLongestString", function () {
      var arr = _this2._getLabelOptions(_this2.props.options);

      return (0, _reduce.default)(arr).call(arr, function (longest, option) {
        return option.label.length >= longest.length ? option.label : longest;
      }, "");
    });

    _this2._setupGroups(props);

    return _this2;
  }

  (0, _createClass2.default)(FormDropDownListStateless, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _context19,
          _this3 = this;

      if ((0, _some.default)(_context19 = ["options", "open", "searchIndex"]).call(_context19, function (propName) {
        return _this3.props[propName] !== prevProps[propName];
      })) {
        this._setSearchListPosition();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("click", this._handleGlobalClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("click", this._handleGlobalClick);
    } // Moving complexity of the stateful version's _handleSearch behavior here

  }, {
    key: "render",
    value: function render() {
      var _context20,
          _this4 = this;

      this._setupGroups(this.props);

      if (this.didPressKey && !this.props.open) {
        this.didPressKey = false;
      }

      var hasIcon = (0, _some.default)(_context20 = this.props.options).call(_context20, function (option) {
        return option.iconName;
      });

      var containerClassName = (0, _classnames.default)("input-custom-select", "input-select", this.props.className, (0, _InputWidths.getInputWidthClass)({
        width: this.props.width,
        className: this.props.className,
        defaultClass: _InputWidths.InputWidths.AUTO
      }), {
        open: this.props.open,
        "form-error": this.props.errorMessage,
        "value-entered": this.props.selectedOption && (!this.props.noneOption || this.props.noneOption.label !== this.props.selectedOption.label),
        required: this.props.required,
        disabled: this.props.disabled
      }),
          selectClassName = (0, _classnames.default)("selected-option", this.props.selectClassName),
          selectedOptionLabelClassName = (0, _classnames.default)("selected-option-label", this.props.selectedOptionLabelClassName, {
        "selected-option-label--icon-padding": this.props.selectedOption && this.props.selectedOption.iconName
      }),
          selectedOptionLabel = this._getSelectedOptionLabel(),
          inputValue = this._isBoxSearch() && this.didPressKey && this.props.open ? this.props.searchString : selectedOptionLabel;

      return /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        value: this.props.label,
        description: this.props.description,
        "data-id": this.props["data-id"],
        ref: "form-drop-down-list",
        className: containerClassName,
        hint: this.props.labelHelpText
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "input-container",
        ref: "input-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        "data-id": "selected-option",
        ref: "selected-option",
        onClick: this._handleToggle,
        onKeyDown: this._handleKeyDown,
        className: selectClassName,
        title: this.props.title
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "wrapper__spacer"
      }, this._getLongestString()) // for auto-sized dropdowns, it pushes out the width of the input
      , this.props.renderInput({
        "data-id": "selected-input",
        disabled: this.props.disabled,
        inputClassName: selectedOptionLabelClassName,
        helpClassName: this.props.helpClassName,
        errorMessage: this.props.errorMessage,
        autoFocus: this.props.autofocus,
        selectOnFocus: this._isBoxSearch(),
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        value: inputValue,
        placeholder: this.props.placeholder,
        name: this.props.name,
        onValueChange: this._handleInputValueChange,
        iconLeft: this.props.selectedOption && this.props.selectedOption.iconName ? this.props.selectedOption.iconName : undefined,
        readOnly: this.props.disabled || this._isKeyboardSearch(),
        width: _InputWidths.InputWidths.MAX,
        ref: function ref(el) {
          return _this4.reference = el;
        }
      }, _index2.FormTextFieldStateless), !this.props.disabled && /*#__PURE__*/_react.default.createElement("div", {
        className: "arrow"
      })), this.props.open && /*#__PURE__*/_react.default.createElement(_PopperContainer.default, {
        "data-parent": this.props["data-id"],
        "data-id": this.props["data-id"] + "-dropdown",
        getReference: this._getReference,
        className: containerClassName,
        placement: "bottom-start",
        matchWidth: true,
        noGPUAcceleration: true,
        hasPopperParent: this.context
      }, this.props.renderList({
        "data-id": "select-list",
        className: "select-list",
        ref: "selectList",
        style: this.inlineMenuStyle,
        children: [this._getPrompt(), this._generateOptions(hasIcon)]
      }, "ul")))));
    }
  }]);
  return FormDropDownListStateless;
}(_react.default.Component);

(0, _defineProperty2.default)(FormDropDownListStateless, "displayName", "FormDropDownListStateless");
(0, _defineProperty2.default)(FormDropDownListStateless, "propTypes", {
  autofocus: _propTypes.default.bool,
  canAdd: _propTypes.default.bool,
  className: _propTypes.default.string,
  contentType: _propTypes.default.element,
  "data-id": _propTypes.default.string,
  disabled: _propTypes.default.bool,
  errorMessage: _propTypes.default.node,
  groups: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    label: _propTypes.default.string,
    disabled: _propTypes.default.bool
  })),
  helpClassName: _propTypes.default.string,
  label: _propTypes.default.node,
  description: _propTypes.default.node,
  labelAdd: _propTypes.default.string,
  labelHelpText: _propTypes.default.string,
  labelPrompt: _propTypes.default.string,
  name: _propTypes.default.string,
  noneOption: _propTypes.default.object,
  noneOptionLabelClassName: _propTypes.default.string,
  onValueChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  open: _propTypes.default.bool,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  })),
  onSearch: _propTypes.default.func,
  setSearchIndex: _propTypes.default.func,
  setSearchString: _propTypes.default.func,
  setSearchTime: _propTypes.default.func,
  onToggle: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  required: _propTypes.default.bool,
  searchField: _propTypes.default.string,
  searchIndex: _propTypes.default.number,
  searchString: _propTypes.default.string,
  searchTime: _propTypes.default.number,
  searchType: _propTypes.default.oneOf([SearchTypes.KEYBOARD, SearchTypes.BOX]),
  selectClassName: _propTypes.default.string,
  selectedOption: _propTypes.default.object,
  selectedOptionLabelClassName: _propTypes.default.string,
  title: _propTypes.default.string,
  validSearchCharsRegex: _propTypes.default.string,
  width: _propTypes.default.oneOf(_InputWidths.InputWidthProptypes),
  renderInput: _propTypes.default.func,
  renderList: _propTypes.default.func
});
(0, _defineProperty2.default)(FormDropDownListStateless, "defaultProps", {
  "data-id": "form-drop-down-list",
  onValueChange: _underscore.default.noop,
  contentType: /*#__PURE__*/_react.default.createElement(FormDropDownListDefaultContent, null),
  open: false,
  onToggle: _underscore.default.noop,
  onFocus: _underscore.default.noop,
  onBlur: _underscore.default.noop,
  canAdd: false,
  searchString: "",
  searchField: "label",
  validSearchCharsRegex: "/[^a-zA-Z\d\s]+/",
  searchIndex: -1,
  searchTime: 0,
  searchType: SearchTypes.KEYBOARD,
  onSearch: _underscore.default.noop,
  setSearchIndex: _underscore.default.noop,
  setSearchString: _underscore.default.noop,
  setSearchTime: _underscore.default.noop,
  title: "",
  showSelectedOptionLabel: true,
  required: false,
  disabled: false,
  autofocus: false,
  renderInput: _PropUtils.defaultRender,
  renderList: _PropUtils.defaultRender
});
FormDropDownListStateless.contextType = _PopperContainerContext.default;
var DropDownList = (0, _StateContainer.inStateContainer)([{
  name: "open",
  initial: false,
  callbacks: [{
    name: "onToggle",
    transform: _StateContainer.toggleTransform
  }]
}, {
  name: "searchIndex",
  initial: -1,
  setter: "setSearchIndex"
}, {
  name: "searchString",
  initial: "",
  setter: "setSearchString"
}, {
  name: "searchTime",
  initial: 0,
  setter: "setSearchTime"
}])(FormDropDownListStateless);
DropDownList.displayName = "FormDropDownList";
DropDownList.propTypes = {
  stateless: _DeprecationUtils.deprecatedStatelessProp
};
DropDownList.SearchTypes = SearchTypes;
DropDownList.searchTypes = SearchTypes; // we agreed on a new naming standard, but I'm also preserving bw compat

DropDownList.filterOptions = filterOptions;
DropDownList._statelessComponent = FormDropDownListStateless;

DropDownList.optionFromValue = function (options, fromValue) {
  return (0, _find.default)(options).call(options, function (_ref9) {
    var value = _ref9.value;
    return value === fromValue;
  });
};

var _default = DropDownList;
exports.default = _default;
module.exports = exports["default"];